import { Component, OnInit } from '@angular/core';
import { GeneralConfigType, Graph, GraphData, LocalService, Paging } from '../../../service/local.service';
import { ChartConfiguration, ChartOptions, ChartType } from "chart.js";

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss']
})
export class GraphComponent implements OnInit {
  paging: Paging; data: any; graph: Graph; graphDataByAmount: GraphData[]; graphDataByQuantity: GraphData[]; graphDataByProfit: GraphData[];
  graphConfigType: GeneralConfigType = GeneralConfigType.None; width: number = 500; height: number = 150;
  value1: string; value2: string; value3: string; isShow: boolean = false;
  isShowQuantity: boolean = true; isShowProfit: boolean = false;
  isByProfit: boolean = false; isByQuantity: boolean = false; isByAmount: boolean = true;

  lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: 'Sales',
        tension: 0.2,
        borderColor: '#008cba',
        backgroundColor: '#008cba'
      }
    ]
  };
  lineChartOptions: ChartOptions<'line'> = {
    responsive: true
  };
  lineChartLegend = true;

  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    this.onLoad(3);
  }

  onChecked(iValue: number) {
    this.isByProfit = false;
    this.isByQuantity = false;
    this.isByAmount = false;

    switch (iValue) {
      case 1: {
        this.isByProfit = true;
      } break;
      case 2: {
        this.isByQuantity = true;
      } break;
      case 3: {
        this.isByAmount = true;
      } break;
    }

    this.isShow = false;
    setTimeout(() => {
      this.onLoad(iValue);
    }, 10);
  }

  onLoad(iValue: number) {
    switch (iValue) {
      case 1: {
        if (this.graphDataByProfit) {
          this.lineChartData.labels = this.graphDataByProfit.map(x => x.x);
          this.lineChartData.datasets[0].data = this.graphDataByProfit.map(x => x.y);
        }
      } break;
      case 2: {
        if (this.graphDataByQuantity) {
          this.lineChartData.labels = this.graphDataByQuantity.map(x => x.x);
          this.lineChartData.datasets[0].data = this.graphDataByQuantity.map(x => x.y);
        }
      } break;
      case 3: {
        if (this.graphDataByAmount) {
          this.lineChartData.labels = this.graphDataByAmount.map(x => x.x);
          this.lineChartData.datasets[0].data = this.graphDataByAmount.map(x => x.y);
        }
      } break;
    }

    this.isShow = true;
  }
}
